<zwi-embed-sermon-list-container>
  @for (s of sermons; track s.id) {
    <zwi-sermon-list-item (click)="emitSelectedSermon(s)" [active]="sermonService.sermon().id === s.id" [sermon]="s"></zwi-sermon-list-item>
  }
</zwi-embed-sermon-list-container>

